const LocalStoreKeys = {
  SETTINGS: "settings",
  PORTFOLIO_ID: "lastPortfolioSelected",
  PORTFOLIO_GROUP_ID: "portfoliosGroup",
  FILTER_ID: "currentFilterId",
  DISPLAY_TYPE: "displayType",
  LITMUS_VIEW_MODE: "litmusViewMode",
  BENCHMARK: "benchmark",
}

function nestedSet(obj, path, value) {
  let schema = obj
  const pathList = path.split(".")
  const length = pathList.length
  for (let i = 0; i < length - 1; i++) {
    const elem = pathList[i]
    if (!schema[elem]) schema[elem] = {}
    schema = schema[elem]
  }
  schema[pathList[length - 1]] = value
}

function nestedGet(obj, path) {
  const a = path.split(".")
  for (let i = 0, n = a.length; i < n; ++i) {
    const k = a[i]
    if (k in obj) {
      obj = obj[k]
    } else {
      return
    }
  }
  return obj
}

class LocalStore {
  init(localStorage, accountId) {
    this.localStorage = localStorage
    this.accountId = accountId
  }

  getSettings() {
    const settings = this.getInternalSettings()
    return settings[this.accountId] || {}
  }

  get(key) {
    return nestedGet(this.getInternalSettings(), this.keyWithAccount(key))
  }

  set(key, value) {
    const settings = this.getInternalSettings()
    nestedSet(settings, this.keyWithAccount(key), value)
    this.localStorage.setItem(LocalStoreKeys.SETTINGS, JSON.stringify(settings))
  }

  getInternalSettings() {
    let settings = this.localStorage.getItem(LocalStoreKeys.SETTINGS) || {}
    if (Object.keys(settings).length > 0) {
      settings = JSON.parse(settings)
    }
    return settings
  }

  keyWithAccount(key) {
    return `${this.accountId}.${key}`
  }
}

export { LocalStore, LocalStoreKeys }

const localStore = new LocalStore()
export default localStore
